import React, { useState, useCallback, memo, useEffect } from 'react'
import { NativeTypes } from 'react-dnd-html5-backend'
import { Dustbin } from './dustbin'
import { Box } from './box'
import update from 'immutability-helper'
import { Sentences, getRandomSentence } from '../data/sentences'
import { AiFillSound } from '@react-icons/all-files/ai/AiFillSound'
import { speech, shuffle } from '../utils/utils'
import Switch from 'react-switch'

export const Container = memo(function Container() {
  let randomSentence = getRandomSentence()
  let words = Sentences.flat()
  words = shuffle(
    words.filter(
      (item, index) =>
        !randomSentence.includes(item) && words.indexOf(item) === index
    )
  )
  let new_words = [...randomSentence, ...words.slice(0, 5)]
  const [sentence, setSentence] = useState(randomSentence)
  const [dustbins, setDustbins] = useState(bin_arr(randomSentence))
  const [boxes, setBoxes] = useState(box_arr(new_words))
  const [droppedBoxNames, setDroppedBoxNames] = useState([])
  const [tip, setTip] = useState(true)

  useEffect(() => {
    speech(sentence.join(''))
  }, [])

  function bin_arr(sentence) {
    return sentence.map((char) => {
      return { accepts: [char], lastDroppedItem: null }
    })
  }
  function box_arr(words) {
    return shuffle(words).map((char) => {
      return { name: char, type: char }
    })
  }

  function listenQuestion() {
    speech(sentence.join(''))
  }
  function changeQuestion() {
    let randomSentence = getRandomSentence()
    let words = Sentences.flat()
    words = shuffle(
      words.filter(
        (item, index) =>
          !randomSentence.includes(item) && words.indexOf(item) === index
      )
    )
    let new_words = [...randomSentence, ...words.slice(0, 3)]
    setSentence(randomSentence)
    setDustbins(bin_arr(randomSentence))
    setBoxes(box_arr(new_words))
    speech(randomSentence.join(''))
  }
  function isDropped(boxName) {
    return droppedBoxNames.indexOf(boxName) > -1
  }

  function onSwitchChange() {
    setTip(!tip)
  }

  const handleDrop = useCallback(
    (index, item) => {
      const { name } = item
      setDroppedBoxNames(
        update(droppedBoxNames, name ? { $push: [name] } : { $push: [] })
      )
      setDustbins(
        update(dustbins, {
          [index]: {
            lastDroppedItem: {
              $set: item,
            },
          },
        })
      )
    },
    [droppedBoxNames, dustbins]
  )
  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'grid',
          gap: '1rem',
          gridTemplateColumns: 'repeat(auto-fill, minmax(10rem, 1fr))',
        }}
      >
        {dustbins.map(({ accepts, lastDroppedItem }, index) => (
          <Dustbin
            accept={accepts}
            lastDroppedItem={lastDroppedItem}
            onDrop={(item) => handleDrop(index, item)}
            key={index}
            tip={tip}
          />
        ))}
      </div>

      <div style={{ overflow: 'hidden', clear: 'both' }}>
        {boxes.map(({ name, type }, index) => (
          <Box
            name={name}
            type={type}
            isDropped={isDropped(name)}
            key={index}
          />
        ))}
      </div>
      <div style={{ marginBottom: '5px' }}>
        <button onClick={listenQuestion} style={{ marginRight: '20px' }}>
          听题 &nbsp;
          <AiFillSound />
        </button>

        <button onClick={changeQuestion}>换一题</button>
      </div>

      <div>
        <span>给我提示</span>
        <Switch onChange={onSwitchChange} checked={tip} />
      </div>
    </div>
  )
})
